import { render } from "./sharepointFileTree.vue?vue&type=template&id=d47b7074&scoped=true"
import script from "./sharepointFileTree.vue?vue&type=script&lang=js"
export * from "./sharepointFileTree.vue?vue&type=script&lang=js"

import "./sharepointFileTree.vue?vue&type=style&index=0&id=d47b7074&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47b7074"]])

export default __exports__